import style from '../expertise.module.scss';
import Image from 'next/image';
import Link from 'next/link';
import Breadcrumbs from '../../shared/miscellaneous/breadcrumbs/breadcrumbs';
import localstyle from './insights.module.scss';
import { ButtonHandshkaeGreen } from '@components/shared/buttons/button-handshake-green';

const InsightsComponent = () => {
  const insightsState = {
    cards: [
      {
        title: 'Process',
        text: 'The digital product development process implies multi-step activities that start from the moment you get an idea about your future solution and last till it’s transformed into a full-scale platform. The process gets significantly facilitated when the project development is properly thought through. This is the approach we follow at Agilie.',
        link: '/blog/what-is-the-software-development-life-cycle-sdlc-and-how-does-it-work',
      },
      {
        title: 'Agile Development',
        text: 'This iterative methodology serves to ensure the superior quality of the final solution, thus, enhancing customer satisfaction. Agile project management allows better control, improving project predictability. The given development technique reduces risks and increases product flexibility.',
        link: '/blog/agile-software-development-lifecycle',
      },
      {
        title: 'SDLC',
        text: 'The concept of the Software Development Life Cycle is especially crucial when it comes to the development of advanced powerful software. This process enables creating first-class digital products, both websites and applications, allowing entrepreneurs to promote and grow their businesses.',
        link: '/expertise/insights/sdlc',
      },
      {
        title: 'Discovery phase',
        text: 'Being part of SDLC, the Discovery stage helps to deliver high-quality results without wasting time and money. It ensures transparent communication between the team members and enables the software to swiftly drive revenue. When conducted professionally, Discovery activities allow the target audience to obtain what they need.',
        link: '/expertise/discovery',
      },
    ],
  };
  return (
    <>
      <Breadcrumbs />
      <section className={`${style.section} ${style.section_light}`}>
        <div className={`${style.container} ${style.container_large}`}>
          <div className={`${style.introduction__block}`}>
            <div className={style.introduction__block__text}>
              <h1 className={style.introduction__block__text__title}>Our Technology Insights</h1>
              <div className={style.introduction__block__text__subtext}>
                Now we shall uncover Agilie’s valuable insights regarding the software engineering market. We’ll help
                you figure out how to determine the most optimal instruments to accelerate your digital solutions.
              </div>
            </div>
            <div className={style.introduction__block__image}>
              <Image
                alt="Competence and Expertise"
                src={'/insights-images/introduce-image.png'}
                layout={'fill'}
                sizes="300px"
              />
            </div>
          </div>
        </div>
      </section>
      <section className={`${style.section} ${style.section_gray}`}>
        <div className={`${style.container} ${style.container_large}`}>
          <div className={style.card__items}>
            {insightsState.cards.map((item: any, index: number) => {
              return (
                <div key={index} className={`${style.card__item} ${localstyle.flex}`}>
                  <div>
                    <h3 className={style.card__item__title}>{item.title}</h3>
                    <div className={style.card__item__text}>{item.text}</div>
                  </div>
                  <div className={style.button}>
                    <ButtonHandshkaeGreen text="Learn More" link={item.link} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default InsightsComponent;
